module.exports = __webpack_public_path__ + "img/evgeniy.badb61f9.png";